module.exports = __webpack_public_path__ + "img/57.fe1b4f6a.png";